class AnnouncementBarHeight {
  constructor() {
    this.announcementBar = document.querySelector('.announcement-bar-section-v2');
    this.sectionHeader = document.querySelector('.section-header');
    
    if (!this.announcementBar) {
      // No announcement bar present, ensure body doesn't have the class
      document.body.classList.remove('has-announcement-bar');
      return;
    }
    
    // Add body class to indicate announcement bar is present
    document.body.classList.add('has-announcement-bar');
    
    this.init();
  }

  init() {
    // Calculate height on load
    this.updateHeight();
    
    // Update height on window resize
    window.addEventListener('resize', this.debounce(this.updateHeight.bind(this), 250));
    
    // Update height when content changes (useful for sliders)
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateHeight();
      });
      this.resizeObserver.observe(this.announcementBar);
    }
    
    // Listen for slider changes if announcement bar has a slider
    const slider = this.announcementBar.querySelector('.slider');
    if (slider) {
      slider.addEventListener('scroll', this.debounce(this.updateHeight.bind(this), 100));
    }

    // Listen for announcement bar slide changes
    const sliderButtons = this.announcementBar.querySelectorAll('.slider-button');
    sliderButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Use a slight delay to allow the slide transition to complete
        setTimeout(() => this.updateHeight(), 300);
      });
    });
  }

  updateHeight() {
    if (!this.announcementBar) return;
    
    // Get the actual height of the announcement bar
    const height = this.announcementBar.offsetHeight;
    
    // Update CSS custom property
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    
    // Also update header bottom position for menu drawer if it exists
    if (this.sectionHeader) {
      const headerRect = this.sectionHeader.getBoundingClientRect();
      const borderOffset = this.sectionHeader.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(headerRect.bottom - borderOffset)}px`
      );
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AnnouncementBarHeight();
  });
} else {
  new AnnouncementBarHeight();
}
